// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"6817f349","196":"0b983d6a","315":"485711ad","571":"6817f349","692":"0b983d6a","919":"47767372"}[chunkId] + ".chunk.css";
};